// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609251104/js/" + chunkId + "." + {"44":"93a1bd3b","225":"437039db","481":"30599a72","486":"99624efc","770":"96a57913"}[chunkId] + ".0.7601516781496263.chunk.js";
};